import Vue from 'vue';
import SocketIO from 'socket.io-client';
import store from '@/store';
import IOApi from '../lib/vmol-socketio-gateway-client';

const socket = SocketIO(process.env.VUE_APP_SOCKETIO_HOST, {
  autoConnect: false,
  path: process.env.VUE_APP_SOCKETIO_PATH,
  withCredentials: true,
});

Vue.prototype.$mol = new IOApi(socket, {
  reconnectOnDisconnect: true,
  reconnectOnError: true,
  debug: !!process.env.VUE_APP_LOCAL,

  retryCallback(err) {
    if (String(err).includes('unauthorized')) {
      store.dispatch('auth/refreshToken')
        .then(() => {
          Vue.prototype.$mol.connect();
        });

      return false;
    }

    return true;
  },
});

Vue.prototype.$mol.connect();
